import React, { createContext, useEffect, useMemo, useState } from 'react';
import { auth, firestore } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';

export const AuthContext = createContext({ currentUser: null, userRole: null, loading: true });

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole]       = useState(null);
  const [loading, setLoading]         = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      setLoading(true);
      if (!user) {
        setCurrentUser(null);
        setUserRole(null);
        setLoading(false);
        return;
      }
      setCurrentUser(user);
      const ref  = doc(firestore, 'users', user.uid);
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        await setDoc(ref, { uid: user.uid, role: 'client', createdAt: serverTimestamp() }, { merge: true });
        setUserRole('client');
      } else {
        setUserRole(snap.data()?.role || 'client');
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const value = useMemo(() => ({ currentUser, userRole, loading }), [currentUser, userRole, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
